import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import Overview from "@/pages/dashboard/Overview";
import WalletTab from "@/pages/dashboard/WalletTab";
import SellTab from "@/pages/dashboard/SellTab";
import ProcurementTab from "@/pages/dashboard/ProcurementTab";
import CreditTab from "@/pages/dashboard/CreditTab";
import SalesTab from "@/pages/dashboard/SalesTab";
import AnalyticsTab from "@/pages/dashboard/AnalyticsTab";
import CustomersTab from "@/pages/dashboard/CustomersTab";
import LogisticsTab from "@/pages/dashboard/LogisticsTab";
import NearbyTab from "@/pages/dashboard/NearbyTab";
import SubscriptionsTab from "@/pages/dashboard/SubscriptionsTab";
import AdminConsole from "@/pages/AdminConsole";
import SuperAgentConsole from "@/pages/SuperAgentConsole";
import SupplierPortal from "@/pages/SupplierPortal";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
    return (
        <div className="App">
            <I18nProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <Toaster position="top-right" richColors closeButton />
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route
                                path="/dashboard"
                                element={
                                    <ProtectedRoute>
                                        <Dashboard />
                                    </ProtectedRoute>
                                }
                            >
                                <Route index element={<Overview />} />
                                <Route path="wallet" element={<WalletTab />} />
                                <Route path="sell" element={<SellTab />} />
                                <Route path="procurement" element={<ProcurementTab />} />
                                <Route path="logistics" element={<LogisticsTab />} />
                                <Route path="nearby" element={<NearbyTab />} />
                                <Route path="subscriptions" element={<SubscriptionsTab />} />
                                <Route path="credit" element={<CreditTab />} />
                                <Route path="sales" element={<SalesTab />} />
                                <Route path="analytics" element={<AnalyticsTab />} />
                                <Route path="customers" element={<CustomersTab />} />
                            </Route>
                            <Route path="/admin" element={<ProtectedRoute><AdminConsole /></ProtectedRoute>} />
                            <Route path="/agent" element={<ProtectedRoute><SuperAgentConsole /></ProtectedRoute>} />
                            <Route path="/supplier" element={<ProtectedRoute><SupplierPortal /></ProtectedRoute>} />
                        </Routes>
                    </BrowserRouter>
                </AuthProvider>
            </I18nProvider>
        </div>
    );
}

export default App;
